import { EditOutlined } from '@ant-design/icons'
import { Button, Space, Tooltip } from 'antd'
import { FC, useState } from 'react'
import formatNumber from '../../../../../helpers/formatters/format-any-number'
import RewindJob from '../../../../../types/api/rewind-job'
import { getRewindJobCopies } from '../../helpers/get-rewind-job-copies'
import { getShipmentCopies } from '../../helpers/get-shipment-copies'
import RewindCopiesModal from '../rewind-copies-modal/rewind-copies-modal'

interface RewindCopiesCellProps {
    rewindJob?: RewindJob
    editable?: boolean
}

const RewindCopiesCell: FC<RewindCopiesCellProps> = ({ rewindJob, editable }) => {
    const [open, setOpen] = useState(false)
    const shipment = rewindJob?.shipment
    const isSplit = (shipment?.rewind_jobs || []).length > 1
    const copies = formatNumber(getRewindJobCopies(rewindJob))

    if (!isSplit || !shipment) return <>{copies}</>

    return (
        <Space size={4}>
            <Tooltip
                title={`Часть тиража. Тираж отгрузки: ${formatNumber(getShipmentCopies(shipment))}`}
            >
                <span>{copies}</span>
            </Tooltip>
            {editable && (
                <>
                    <Button
                        type='text'
                        size='small'
                        icon={<EditOutlined />}
                        title='Изменить тираж по станкам'
                        onClick={() => setOpen(true)}
                    />
                    <RewindCopiesModal
                        shipment={shipment}
                        open={open}
                        onClose={() => setOpen(false)}
                    />
                </>
            )}
        </Space>
    )
}

export default RewindCopiesCell
